<app-review-rating [Displaytype]="2"  [productId]="productId" > </app-review-rating>